var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPauseCircle = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pause-circle__fill-stroke",
    d: "M11.97 22.75C6.32581 22.75 1.71997 18.1536 1.71997 12.5C1.71997 6.84645 6.32581 2.25 11.97 2.25C17.6141 2.25 22.22 6.84645 22.22 12.5C22.22 18.1539 17.6238 22.75 11.97 22.75ZM11.97 2.75C6.59383 2.75 2.21997 7.12386 2.21997 12.5C2.21997 17.8761 6.59383 22.25 11.97 22.25C17.3461 22.25 21.72 17.8761 21.72 12.5C21.72 7.12386 17.3461 2.75 11.97 2.75Z",
    fill: "#757575",
    stroke: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pause-circle__fill-stroke",
    d: "M10.4999 15.3823H10.4999L10.4999 15.387C10.5039 15.8121 10.3958 16.0863 10.2589 16.2464C10.13 16.397 9.93084 16.5 9.62224 16.5H8.38713C8.0728 16.5 7.87404 16.3963 7.74575 16.2464C7.60847 16.0859 7.5 15.8105 7.5 15.3823V9.61772C7.5 9.19163 7.60976 8.91598 7.74851 8.75458C7.87893 8.60286 8.07883 8.5 8.38713 8.5H9.61274C9.92707 8.5 10.1258 8.60366 10.2541 8.75364C10.3914 8.91414 10.4999 9.18946 10.4999 9.61772V15.3823ZM7.92513 15.2903L7.92428 15.7911H8.42513H9.58424H10.0842V15.2911V9.70886V9.20886H9.58424H8.43463H7.93548L7.93463 9.70801L7.92513 15.2903Z",
    fill: "#757575",
    stroke: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pause-circle__fill",
    d: "M15.6128 17H14.3872C13.5131 17 13 16.3962 13 15.3823V9.61772C13 8.6038 13.5226 8 14.3872 8H15.6128C16.4869 8 17 8.6038 17 9.61772V15.3823C17 16.3962 16.4774 17 15.6128 17ZM14.4157 15.2911H15.5748V9.70886H14.4252L14.4157 15.2911Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPauseCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause-circle.d35a3b50.svg";
export { ForwardRef as ReactComponent };